import React from 'react';
import { useTranslation } from 'react-i18next';
import { theme } from '../theme';

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  fullScreen?: boolean;
  text?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'medium',
  fullScreen = false,
  text
}) => {
  const { t } = useTranslation();
  
  // Déterminer la taille du spinner
  const sizeMap = {
    small: 'w-6 h-6',
    medium: 'w-10 h-10',
    large: 'w-16 h-16'
  };

  const spinnerSize = sizeMap[size];
  
  // Créer le gradient pour le spinner
  const gradientId = `spinner-gradient-${size}`;
  
  const spinner = (
    <div className="flex flex-col items-center justify-center">
      <div className={`${spinnerSize} relative`}>
        <svg className="animate-spin" viewBox="0 0 50 50">
          <defs>
            <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor={theme.colors.primary.start} />
              <stop offset="100%" stopColor={theme.colors.primary.end} />
            </linearGradient>
          </defs>
          <circle
            cx="25"
            cy="25"
            r="20"
            stroke="url(#${gradientId})"
            strokeWidth="4"
            fill="none"
            strokeDasharray="80"
            strokeDashoffset="60"
          />
        </svg>
      </div>
      {text && <p className="mt-4 text-gray-400">{text}</p>}
      {!text && fullScreen && <p className="mt-4 text-gray-400">{t('common.loading')}</p>}
    </div>
  );

  // Si fullScreen est true, centrer le spinner sur l'écran entier
  if (fullScreen) {
    return (
      <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50">
        {spinner}
      </div>
    );
  }

  return spinner;
};

export default LoadingSpinner; 